export class TrustScheduleModel {
  public Id: string;
  public DepartmentName: string;
  public TelephoneNumber: string;
  public EmailAddress: string;
  public StartDay: string;
  public EndDay: string;
  public StartHour: string;
  public EndHour: string;
  public StartAmPm: string;
  public EndAmPm: string;
  public Deleted: boolean;
  public ShowEdit: boolean;
  public IsValid:boolean;
  public WebUrl:string;
}


// WEBPACK FOOTER //
// ./src/app/models/trust-schedule-model.ts